module.exports = __webpack_public_path__ + "img/order-new.640ae451.png";